export default __webpack_public_path__ + "static/countdown-bef360b1acb3dfbc73acf0ea85793b50.mp3";